import { AuthngkService } from './../services/authngk.service';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
  constructor(
    private router: Router,
    private authngkService: AuthngkService,
  ) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const currentUser = this.authngkService.currentUserValue;
    console.log('AuthGuard: ', currentUser);
    if (currentUser && currentUser.token != null && currentUser.user != null) {
      return true;
    }
    // not logged in so redirect to login page with the return url
    this.router.navigate(['/account/login']);
    return false;
  }
}
